import apiWrapper from '../../../services/apiWrapper';

export const fetchFulfillmentPartners = async () => {
  try {
    const response = await apiWrapper('get', '/fulfillment-partners');
    return {
      success: response.success,
      partners: Array.isArray(response.partners) ? response.partners : [],
    };
  } catch (error) {
    console.error('Error fetching fulfillment partners:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while fetching fulfillment partners. Please try again later.',
      partners: [],
    };
  }
};

export const fetchFulfillmentPartnerById = async (id) => {
  try {
    const response = await apiWrapper('get', `/fulfillment-partners/${id}`);
    return {
      success: response.success,
      partner: response.partner,
    };
  } catch (error) {
    console.error('Error fetching fulfillment partner:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while fetching the fulfillment partner. Please try again later.',
    };
  }
};

export const createFulfillmentPartner = async (partnerData) => {
  try {
    const response = await apiWrapper('post', '/fulfillment-partners', partnerData);
    return {
      success: true,
      partner: response,
    };
  } catch (error) {
    console.error('Error creating fulfillment partner:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while creating the fulfillment partner. Please try again later.',
    };
  }
};

export const updateFulfillmentPartner = async (id, partnerData) => {
  try {
    const response = await apiWrapper('put', `/fulfillment-partners/${id}`, partnerData);
    return {
      success: true,
      partner: response,
    };
  } catch (error) {
    console.error('Error updating fulfillment partner:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while updating the fulfillment partner. Please try again later.',
    };
  }
};

export const deleteFulfillmentPartner = async (id) => {
  try {
    const response = await apiWrapper('delete', `/fulfillment-partners/${id}`);
    return {
      success: true,
      message: response.message,
    };
  } catch (error) {
    console.error('Error deleting fulfillment partner:', error);
    return {
      success: false,
      message: error.message || 'An error occurred while deleting the fulfillment partner. Please try again later.',
    };
  }
};